import { AuthenticationMethod } from '@/react/portainer/settings/types';
import { usePublicSettings } from '@/react/portainer/settings/queries';
import { Role, RoleNames, User } from '@/portainer/users/types';
import { isInitialAdmin } from '@/portainer/users/user.helpers';

import { DetailsTable } from '@@/DetailsTable';
import { DetailsRow } from '@@/DetailsTable/DetailsRow';
import { Widget, WidgetBody } from '@@/Widget';
import { Badge } from '@@/Badge';

import { UserForm } from './UserForm';
import { PasswordForm } from './PasswordForm';

export function DetailsTab({
  user,
  canEdit,
  isSelf,
}: {
  user: User;
  canEdit: boolean;
  isSelf: boolean;
}) {
  const settingsQuery = usePublicSettings();
  const authMethod = settingsQuery.data?.AuthenticationMethod;
  const requiredPasswordLength = settingsQuery.data?.RequiredPasswordLength;

  const canChangePassword =
    (authMethod === AuthenticationMethod.Internal || isInitialAdmin(user.Id)) &&
    (canEdit || isSelf) &&
    !!requiredPasswordLength;

  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          {canEdit ? <UserForm user={user} /> : <ReadOnlyDetails user={user} />}
        </div>
      </div>

      {canChangePassword && (
        <div className="row">
          <div className="col-sm-12">
            <PasswordForm
              user={user}
              isSelf={isSelf}
              requiredPasswordLength={requiredPasswordLength}
            />
          </div>
        </div>
      )}
    </>
  );
}

function ReadOnlyDetails({ user }: { user: User }) {
  return (
    <Widget>
      <WidgetBody>
        <DetailsTable dataCy="user-details-table">
          <DetailsRow label="Username">{user.Username}</DetailsRow>
          <DetailsRow label="Role">
            <Badge type={user.Role === Role.Standard ? 'muted' : 'info'}>
              {RoleNames[user.Role]}
            </Badge>
          </DetailsRow>
        </DetailsTable>
      </WidgetBody>
    </Widget>
  );
}
